import React from "react";
// @material-ui/core components
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@material-ui/icons/Email";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import { CircularProgress } from "@material-ui/core";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyles = makeStyles(styles);
const useStyleData = makeStyles(stylesData);
export default function LoginPage() {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [otpSent, setOtpSent] = useState(false);
  console.log(otpSent , "otpSentotpSent")
  const [alert, setAlert] = React.useState(null);
  const [loginEmailState, setregisterEmailState] = React.useState("");
  const [loginPasswordState, setregisterPasswordState] = React.useState("");
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
    otp: "",
  });

  const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  React.useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });
  const verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };
  // const validateEmail = (email) => {
  //   return email.match();
  // };
  const handleChangeOTP = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]: e.target.value,
    });
  };
  const handleChange = (e) => {
    if (e.target.type === "email" && verifyEmail(e.target.value)) {
      setFormValues({
        ...formValues,
        [e.target.id]: e.target.value,
      });
      setregisterEmailState("success");
    } else {
      setregisterEmailState("error");
    }

    if (e.target.type === "password" && verifyLength(e.target.value, 1)) {
      setFormValues({
        ...formValues,
        [e.target.id]: e.target.value,
      });
      setregisterPasswordState("success");
    } else {
      setregisterPasswordState("error");
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(formValues);
    let payload = {
      email: formValues.email,
      password: formValues.password,
    };
    if (formValues.email !== "" && formValues.password !== "") {
      try {
        console.log("Login Data", process.env.REACT_APP_API_URL_PREFIX);
        await axios
          .post(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/login`,
            payload
          )
          .then((response) => {
            setAlert(
              <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title={response.data.message}
                onConfirm={() => hideAlert()}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={
                  classesSweetAlert.button + " " + classesSweetAlert.success
                }
              />
            );
            if (
              response.data.message.toLowerCase() ===
              "OTP sent  on your email".toLowerCase()
            ) {
              setOtpSent(true);
            }
          });
      } catch (error) {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={"invalid credentials"}
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={"please provide valid email and password"}
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
      // if (email != "") {
      //   if (validateEmail(email) == null) {
      //     setError("Please Enter Valid Email Address");
      //     console.log(error.error);
      //   } else if (password === "") {
      //     setError("Please Enter your Password");
      //   }
      // } else {
      //   setError("Please Enter Email and Password");
      // }
    }
    // else if (email == "") {
    //   alert("plase Enter your Email ");
    // } else {
    //   alert("Please Enter A Valid Email ");
    // }
  };

  const hideAlert = () => {
    setAlert(null);
  };
  const handleOtpClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    let payload = {
      otp: formValues.otp,
      email: formValues.email,
    };
    await axios
      .post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/verifyotp`,
        payload
      )
      .then((data) => {
        if (data.data.message === "OTP verification successfull") {
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={"OTP verification successful"}
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnCssClass={
                classesSweetAlert.button + " " + classesSweetAlert.success
              }
            />
          );

          localStorage.clear();
          localStorage.setItem("token", data.data.token);
          localStorage.setItem("userId", data.data.userId);
          localStorage.setItem("email", data.data.email);
          localStorage.setItem("usertype", data.data.userType);
          window.location.assign("/admin/dashboard");
        }
      })
      .catch((err) => {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={"Invalid OTP"}
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={4}>
          <form onSubmit={!otpSent ? handleClick : handleOtpClick}>
            <Card login className={classes[cardAnimaton]}>
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="rose"
              >
                <h4 className={classes.cardTitle}>Log in</h4>
              </CardHeader>
              <CardBody>
                <CustomInput
                  success={loginEmailState === "success"}
                  error={loginEmailState === "error"}
                  labelText="Email"
                  id="email"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  name="email"
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Email className={classes.inputAdornmentIcon} />
                      </InputAdornment>
                    ),
                    type: "email",
                  }}
                  handleChange={handleChange}
                />
                <CustomInput
                  success={loginPasswordState === "success"}
                  error={loginPasswordState === "error"}
                  labelText="Password"
                  id="password"
                  name="password"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  handleChange={handleChange}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Icon className={classes.inputAdornmentIcon}>
                          lock_outline
                        </Icon>
                      </InputAdornment>
                    ),
                    type: "password",
                    autoComplete: "off",
                  }}
                />
                {otpSent ? (
                  <CustomInput
                    labelText="otp"
                    id="otp"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    handleChange={handleChangeOTP}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                          <Button
                            onClick={handleClick}
                            type="submit"
                            color="rose"
                            simple
                            size="lg"
                            block
                          >
                            Resend Otp
                          </Button>
                        </InputAdornment>
                      ),
                      type: "text",
                      autoComplete: "off",
                    }}
                  />
                ) : (
                  <div></div>
                )}
              </CardBody>
              <CardFooter className={classes.justifyContentCenter}>
                {!loading ? (
                  <Button
                    style={{ marginLeft: 120 }}
                    type="submit"
                    color="rose"
                    size="lg"
                    block
                  >
                    Sign in
                  </Button>
                ) : (
                  <div style={{ marginLeft: 145 }}>
                    <CircularProgress sx={{ marginLeft: "10px" }} />
                  </div>
                )}
                {alert}
                <Button
                  style={{ marginLeft: -97, marginTop: -80 }}
                  color="rose"
                  simple
                  size="lg"
                  block
                  onClick={() => window.location.assign("/auth/forgetpassword")}
                >
                  Forgot Password
                </Button>
              </CardFooter>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
